import { NgModule }      from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule }   from '@angular/forms';
import { HttpModule }    from '@angular/http';
import { AppComponent }         from './app.component';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';

import { 
  LoaderService, 
  ConfigService, 
  PesquisaService,
  MapaService,
  HeadersService
} from './lib/service';

//Carrega os componentes que serão 'roteados' na aplicaçao
import { 
  PesquisaComponent, 
  MapaComponent, 
  ResultadoPesquisaComponent ,
  PaginatorComponent,
  LegendaComponent,
  PesquisaTouchComponent
} from './lib/component';

import {CepDirective,
         BordaAnimadaDirective,
         ApenasLetrasDirective, 
         ApenasNumeroDirective, 
         UppercaseDirective,
         TelefoneDirective} from './lib/directives';

import {DataPipe, RealPipe, MesPipe} from './lib/pipe';

import { DataTableModule,SharedModule } from 'primeng/primeng';  

import { TextMaskModule } from 'angular2-text-mask';
import { TecladoComponent } from './pesquisa/pesquisa-touch/teclado/teclado.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    DataTableModule,
    SharedModule,
    AppRoutingModule,
    TextMaskModule
  ],
  declarations: [
    AppComponent,
    PesquisaComponent,
    PesquisaTouchComponent,
    MapaComponent,
    ResultadoPesquisaComponent,
    CepDirective,
    BordaAnimadaDirective,
    ApenasLetrasDirective,
    ApenasNumeroDirective,
    UppercaseDirective,
    TelefoneDirective,
    DataPipe, 
    RealPipe, 
    MesPipe,
    PaginatorComponent,
    LegendaComponent,
    TecladoComponent
  ],
  providers: [
    LoaderService,
    ConfigService,
    HeadersService,
    PesquisaService,
    MapaService
  ],
  bootstrap: [ AppComponent ]
})

export class AppModule { }


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.module.ts
 **/